module.exports = __webpack_public_path__ + "img/tree_2_4.29ca4331.png";